var map = {
	".": 25964,
	"./": 25964,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Cards": 21080,
	"./Cards.jsx": 21080,
	"./Carrousel": 32862,
	"./Carrousel.jsx": 32862,
	"./Content": 82582,
	"./Content.jsx": 82582,
	"./Footer": 80083,
	"./Footer.jsx": 80083,
	"./Home": 99369,
	"./Home.jsx": 99369,
	"./Img/0.png": 92076,
	"./Img/00.png": 30210,
	"./Img/0001.png": 97509,
	"./Img/0002.png": 86440,
	"./Img/0003.png": 29749,
	"./Img/0004.png": 27335,
	"./Img/0005.png": 69760,
	"./Img/0006.png": 34717,
	"./Img/0007.png": 29348,
	"./Img/1.png": 53475,
	"./Img/11.png": 96905,
	"./Img/2.png": 22945,
	"./Img/22.png": 30474,
	"./Img/Flyer.png": 10903,
	"./Img/donuts paradise.png": 92985,
	"./Mapa": 44592,
	"./Mapa.jsx": 44592,
	"./Navbar": 40797,
	"./Navbar.jsx": 40797,
	"./Politicas_De_Privacidad": 6455,
	"./Politicas_De_Privacidad.jsx": 6455,
	"./Tienda": 50017,
	"./Tienda.jsx": 50017,
	"./Términos_y_Condiciones": 4701,
	"./Términos_y_Condiciones.jsx": 4701,
	"./asdasd.png": 77475,
	"./footer_N_M_V": 74169,
	"./footer_N_M_V.jsx": 74169,
	"./index": 25964,
	"./index.css": 51174,
	"./index.js": 25964,
	"./logo.svg": 31100,
	"./output": 40803,
	"./output.json": 40803,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;